export default __webpack_public_path__ + "static/media/about.4ff3da45.jpg";